import WixIntegration from './WixIntegration';
export default WixIntegration;
